// components/DeleteConfirmModal.jsx — Anamoria SPA
// v1.1 — 4.3 relabel: "Remove/Keep" register; loading label "Removing…";
//        defaults moved off the retired "trash" wording (July 24, 2026).
//        Copy v0.12 (D-C7). Shared by MemoryDetailPage / VideoPage / RecordPage
//        and (4.3) MomentDetailPage — all pass explicit strings; defaults
//        updated so any future caller inherits the current register.
// v1.0 — Delete confirmation modal (May 17, 2026)
//
// Purpose-built modal for delete actions. Separate from LeaveConfirmModal
// (which handles unsaved-work navigation) to avoid modifying a shared
// component with 4 existing consumers (Option B per Build Plan v1.0).
//
// Props:
//   open      — boolean — controls visibility
//   title     — string — e.g. "Remove this memory?"
//   message   — string — e.g. "This memory will move to Recently Deleted…"
//   confirmLabel — string — destructive action label, e.g. "Remove memory"
//   cancelLabel  — string — dismiss (safe) label, e.g. "Keep memory"
//   onConfirm — function — execute delete
//   onCancel  — function — dismiss modal
//   loading   — boolean — disables buttons during API call
//
// Visual spec: Same card layout as LeaveConfirmModal (backdrop, 340px card,
// centered, 20px radius). Destructive button is red instead of sage.
// Trash icon in header circle with red-tinted background.

import styles from './DeleteConfirmModal.module.css';

function TrashModalIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </svg>
  );
}

export default function DeleteConfirmModal({
  open,
  title = 'Remove this memory?',
  message = 'This memory will move to Recently Deleted. You can bring it back anytime in the next 30 days.',
  confirmLabel = 'Remove memory',
  cancelLabel = 'Keep memory',
  onConfirm,
  onCancel,
  loading = false,
}) {
  if (!open) return null;

  return (
    <div
      className={styles.backdrop}
      onClick={onCancel}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.icon}>
          <TrashModalIcon />
        </div>

        <h3 className={styles.heading}>{title}</h3>
        <p className={styles.message}>{message}</p>

        <div className={styles.actions}>
          <button
            className={styles.cancelBtn}
            onClick={onCancel}
            disabled={loading}
            autoFocus
          >
            {cancelLabel}
          </button>
          <button
            className={styles.confirmBtn}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Removing…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
